import { formValues } from 'redux-form';

const CurrentImportantSettingsContainer = formValues({
    selectedBrandId: 'brandId',
    selectedOverrideBrandEnabledChannels: 'meta.overrideBrand.enabledChannels',
    selectedOverrideBrandTotalActivitiesSetting: 'meta.overrideBrand.showTotalActivities',
    selectOverrideBrandAdvancedOptions: 'meta.overrideBrand.advancedOptions',
})(props => props.children(props));

export default CurrentImportantSettingsContainer;



// WEBPACK FOOTER //
// ./src/containers/forms/entities/CurrentImportantSettingsContainer.js